<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="订单编号" prop="recycleNo">
        <el-input
          v-model="search.recycleNo"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="订单状态" prop="recycleStatusList">
        <el-select
          v-model="search.recycleStatusList"
          multiple
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in BusinessRecycleStatusEnum"
            :key="item.enumCode"
            :label="item.description"
            :value="item.enumCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目编号" prop="projectNo">
        <el-input
          v-model="search.projectNo"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input
          v-model="search.projectName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="省份" prop="provinceId">
        <el-select
          v-model="search.provinceId"
          placeholder="请选择"
          clearable
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市" prop="cityId">
        <el-select
          v-model="search.cityId"
          placeholder="请选择"
          clearable
          :disabled="!search.provinceId"
        >
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input
          v-model="search.contactName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactMobile">
        <el-input
          v-model="search.contactMobile"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="承运商" prop="carrierNoList">
        <el-select
          v-model="search.carrierNoList"
          multiple
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in carrierOption"
            :key="item.partnershipId"
            :label="item.partnerName"
            :value="item.partnershipId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商所属组织" prop="carrierOrg">
        <el-input
          v-model="search.carrierOrg"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createdTime">
        <el-date-picker
          v-model="createdTime"
          clearable
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="预约时间" prop="appointTime">
        <el-date-picker
          v-model="appointTime"
          type="daterange"
          clearable
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="完成时间" prop="completeTime">
        <el-date-picker
          v-model="completeTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>

    <div class="row-bg">
      <el-button type="primary" size="medium" @click="handleSearch()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm">重置</el-button>
      <el-button size="medium" @click="exportExcel">导出</el-button>
    </div>

    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="订单编号"
        prop="recycleNo"
        width="160"
      ></el-table-column>
      <el-table-column label="订单状态" prop="status" width="120">
        <template slot-scope="scope">{{
          scope.row.recycleStatus | changeStatus(BusinessRecycleStatusEnum)
        }}</template>
      </el-table-column>
      <el-table-column
        label="项目编号"
        prop="projectNo"
        width="120"
      ></el-table-column>
      <el-table-column
        label="项目名称"
        prop="projectName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="下单旧机"
        prop="orderCount"
        width="120"
      ></el-table-column>
      <el-table-column
        label="旧机实收"
        prop="actualCount"
        width="120"
      ></el-table-column>
      <el-table-column
        label="承运商"
        prop="carrierName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="承运商所属组织"
        prop="carrierOrg"
        width="120"
      ></el-table-column>
      <el-table-column
        label="联系人"
        prop="contactName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        prop="contactMobile"
        width="120"
      ></el-table-column>
      <el-table-column
        label="省"
        min-width="100"
        prop="province"
        align="center"
      >
      </el-table-column>
      <el-table-column label="市" prop="city" width="120"></el-table-column>
      <el-table-column label="区" prop="county" width="120"></el-table-column>
      <el-table-column
        label="详细地址"
        prop="address"
        width="120"
      ></el-table-column>
      <el-table-column label="创建时间" prop="createdDate" width="120">
      </el-table-column>
      <el-table-column label="预约时间" prop="appointDate" width="200">
        <template slot-scope="scope">
          {{ scope.row.appointBeginDate }}
          <span v-if="scope.row.appointBeginDate && scope.row.endAppointDate">
            ~ {{ scope.row.endAppointDate }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="完成时间" prop="completedDate" width="120">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">查看</el-button>
          <el-button
            type="text"
            @click="goAdd(scope.row)"
            v-show="[100, 200, 300].includes(scope.row.recycleStatus)"
            >派车/改派</el-button
          >
          <el-button
            type="text"
            v-show="
              [100, 200, 300].includes(scope.row.recycleStatus) &&
                partnershipType == 3
            "
            @click="goCancel(scope.row)"
            >取消</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.page"
        :page-size="search.size"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <appointmentDialog
      ref="AddDialogRef"
      @opera-success="getList"
    ></appointmentDialog>
  </div>
</template>
<script>
import appointmentDialog from "./components/appointmentDialog";

import {
  findOldMachineRecoveryList,
  cancelOrder,
  getPartnerList,
  findAllProvince,
  findAllCity
} from "@/api/COldForNew";

import enumMixin from "./enumMixin.js";

export default {
  name: "order",
  components: {
    appointmentDialog
  },
  mixins: [enumMixin],
  filters: {
    changeStatus(value, optionList) {
      return value
        ? (optionList.find(item => item.enumCode == value) || {}).description ||
            ""
        : "";
    }
  },

  data() {
    return {
      list: [],
      optionList: {},
      total: null, //列表总条数
      listLoading: false,
      createdTime: [], //开始时间
      appointTime: [], //预约时间
      completeTime: [], //完成时间
      carrierOption: [], //承运商选项列表

      search: {
        page: 1,
        size: 10,
        recycleNo: "", //订单编号
        recycleStatusList: [], //订单状态
        projectNo: "", //项目编号
        projectName: "", //项目名称
        provinceId: "", //省份
        cityId: "", //市
        // countyId: "", //区
        carrierNoList: [], //承运商
        contactName: "", //旧机站点联系人
        contactMobile: "", //旧机站点联系电话
        carrierOrg: "", //承运商所属组织
        startCreatedDate: "", //创建时间-开始
        endCreatedDate: "", //创建时间-结束
        startAppointDate: "", //预约回收时间-开始
        endAppointDate: "", //预约回收时间-结束
        startCompletedDate: "", //回收完成时间-开始
        endCompletedDate: "" //回收完成时间-结束
      },
      provinceList: [], //省份列表
      cityList: [], //市列表
      countyList: [], //区域列表
      hasOldOPtion: { 1: "是", 0: "否" }, //是否有待回收旧机
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      downloadSettlementLoading: false,
      downloadOutboundLoading: false
    };
  },
  computed: {},

  async created() {
    this.getTblProvince();
    this.getPartnerList();

    this.getList();
    // 获取当前账号的组织类型
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
  },
  methods: {
    async handleSearch() {
      this.search.page = 1;
      this.getList();
    },
    async getList() {
      if (this.createdTime && this.createdTime.length) {
        [
          this.search.startCreatedDate,
          this.search.endCreatedDate
        ] = this.createdTime;
        this.setTimeRange(this.createdTime, [
          "startCreatedDate",
          "endCreatedDate"
        ]);
      } else {
        this.search.startCreatedDate = this.search.endCreatedDate = null;
      }

      if (this.appointTime && this.appointTime.length) {
        [
          this.search.startAppointDate,
          this.search.endAppointDate
        ] = this.appointTime;
        this.setTimeRange(this.appointTime, [
          "startAppointDate",
          "endAppointDate"
        ]);
      } else {
        this.search.startAppointDate = this.search.endAppointDate = null;
      }

      if (this.completeTime && this.completeTime.length) {
        [
          this.search.startCompletedDate,
          this.search.endCompletedDate
        ] = this.completeTime;
        this.setTimeRange(this.completeTime, [
          "startCompletedDate",
          "endCompletedDate"
        ]);
      } else {
        this.search.startCompletedDate = this.search.endCompletedDate = null;
      }
      let {
        statusCode,
        data,
        total,
        message
      } = await findOldMachineRecoveryList(this.search);
      if (statusCode == 200) {
        this.list = data || [];
        this.total = total || 0;
      } else {
        this.$message.error(message);
      }
    },
    setTimeRange(timeRange, [startKey, endKey]) {
      if (timeRange && timeRange.length) {
        this.search[startKey] = timeRange[0] + " 00:00:00";
        this.search[endKey] = timeRange[1] + " 23:59:59";
      }
    },
    resetForm() {
      this.search = this.$options.data().search;
      this.completeTime = this.appointTime = this.createdTime = [];
    },
    //提交回收单
    goAdd(row) {
      this.$refs.AddDialogRef.openDialog(row, "edit");
    },
    //车辆信息维护
    goCar(row) {
      this.$refs.carDialogRef.openDialog(row);
    },
    //获取省份列表
    async getTblProvince() {
      this.search.city = "";
      this.search.county = "";

      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.search.cityId = "";
      if (!this.search.provinceId) {
        return;
      }

      let { statusCode, data } = await findAllCity(this.search.provinceId);
      if (statusCode === 200) {
        this.cityList = data;
      }
    },

    handleSizeChange(val) {
      this.search.page = 1;
      this.search.size = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    //取消回收单
    goCancel(row) {
      if (row.recycleNo) {
        this.$dialog({
          title: "温馨提示",
          content: "是否要取消该回收单，取消后不可以恢复！",
          cancel_buttton: "否",
          ok_buttton: "是",
          width: "400px",
          footBtn: "card",
          dialogType: "sighicon",
          onOk: () => {
            this.confirmCancel(row.recycleNo);
          },
          onCancel: () => {
            console.log("cancel");
          }
        });
      }
    },
    //确认取消
    async confirmCancel(recycleNo) {
      let { statusCode, data, message } = await cancelOrder(recycleNo);
      if (statusCode === 200) {
        this.getList();
        this.$message({
          message: "取消成功",
          type: "success"
        });

      } else {
        this.$message({
          message: message,
          type: "error"
        });
      }
    },

    goDetail(rowData) {
      window.open(
        `/COldForNewService/orderDetail?recycleNo=${rowData.recycleNo}`,
        "_blank"
      );
    },
    //获取承运商
    async getPartnerList() {
      const params = {
        currPage: 1,
        pageSize: 10000
      };
      let { statusCode, data } = await getPartnerList(params);
      if (statusCode == 200) {
        this.carrierOption = data;
      }
    },

    // 导出
    exportExcel() {
      if (this.createdTime && this.createdTime.length) {
        this.search.startCreatedDate = this.createdTime[0];
        this.search.endCreatedDate = this.createdTime[1];
      } else {
        this.search.startCreatedDate = this.search.endCreatedDate = null;
      }
      if (this.appointTime && this.appointTime.length) {
        this.search.startAppointDate = this.appointTime[0];
        this.search.endAppointDate = this.appointTime[1];
      } else {
        this.search.startAppointDate = this.search.endAppointDate = null;
      }
      if (this.completeTime && this.completeTime.length) {
        this.search.completeStartDate = this.completeTime[0];
        this.search.completeEndDate = this.completeTime[1];
      } else {
        this.search.completeStartDate = this.search.completeEndDate = null;
      }
      let params = this.search;
      this.global
        .exportExcel(
          // /api/oldMachineRecovery/exportOldMachineRecoveryList
          `/autoapp-default-server-recovery/api/business/recycle/exportPageCondition`,
          params,
          "商用旧机回收订单数据"
        )
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    },
    // 导出出库单
    exportOutboundNoExcel() {
      this.downloadOutboundLoading = true;
      this.HttpService.post(
        `/autoapp-default-server-recovery/api/oldMachineRecovery/exportOldMachineRecoveryOutBoundPhotoCheck`,
        this.search
      ).then(res => {
        if (res.statusCode === 200) {
          let url =
            "/autoapp-default-server-recovery/api/oldMachineRecovery/exportOldMachineRecoveryOutBoundPhoto";
          let title = "导出出库单.zip";
          this.bathDownload(url, this.search, title);
        } else {
          this.$message.error(res.message);
          this.downloadOutboundLoading = false;
        }
      });
    },
    //下载单个结算单
    downloadSettlementById(orderNo) {
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/oldMachineRecovery/downloadExcel/${orderNo}`,
          "",
          "结算单下载"
        )
        .catch(res => {
          let blob = new Blob([res], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        });
    },
    //结算单压缩包导出
    downloadSettlement() {
      this.downloadSettlementLoading = true;
      this.HttpService.post(
        `/autoapp-default-server-recovery/api/oldMachineRecovery/downloadBatchExcelCheck`,
        this.search
      ).then(res => {
        if (res.statusCode === 200) {
          let url =
            "/autoapp-default-server-recovery/api/oldMachineRecovery/downloadBatchExcel";
          let title = "结算单批量导出.zip";
          this.bathDownload(url, this.search, title);
        } else {
          this.$message.error(res.message);
          this.downloadSettlementLoading = false;
        }
      });
    },
    async bathDownload(url, data, filename = "发票.zip") {
      try {
        data = JSON.parse(JSON.stringify(data));
        const response = await this.HttpService({
          method: "post",
          url: url,
          data,
          responseType: "blob"
        });
        console.log("批量下砸", response);

        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.downloadSettlementLoading = false;
          this.downloadOutboundLoading = false;
        }
      } catch (err) {
        console.log(err);
        const reader = new FileReader();
        reader.onload = result => {
          if (!result.target || !result.target.result) {
            this.$message.warning({
              message: "下载不成功"
            });
          }
          this.$message.warning({
            message: "下载不成功",
            description: JSON.parse(result.target.result).message
          });
          this.downloadSettlementLoading = false;
          this.downloadOutboundLoading = false;
        };
        reader.readAsText(err.response.data);
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/order.vue